import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });
const jsonHeaders = () => ({ ...headers(), 'Content-Type': 'application/json' });

const MODUL = 'ziyaret_konu';

export default function ZiyaretTanimlar() {
  const [liste,      setListe]      = useState<any[]>([]);
  const [aramaMetin, setAramaMetin] = useState('');
  const [pasifGoster,setPasifGoster]= useState(false);
  const [secili,     setSecili]     = useState<Set<string>>(new Set());
  const [modalAcik,  setModalAcik]  = useState(false);
  const [duzenlenen, setDuzenlenen] = useState<any>(null);
  const [form,       setForm]       = useState({ ad: '', aciklama: '', sira: 0 });
  const [hata,       setHata]       = useState('');
  const [mesaj,      setMesaj]      = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => { yukle(); }, [pasifGoster]);

  const yukle = () => {
    const aktif = pasifGoster ? 'hepsi' : '1';
    fetch(`${API}/api/tanimlar2/liste?modul=${MODUL}&sadece_yaprak=false&aktif=${aktif}`, { headers: headers() })
      .then(r => r.ok ? r.json() : [])
      .then(d => setListe(d))
      .catch(() => setListe([]));
  };

  const bildir = (msg: string) => { setMesaj(msg); setTimeout(() => setMesaj(''), 3000); };

  const filtrelenmis = liste.filter(t => {
    if (!aramaMetin) return true;
    return t.ad.toLowerCase().includes(aramaMetin.toLowerCase()) ||
           (t.aciklama || '').toLowerCase().includes(aramaMetin.toLowerCase());
  });

  // Checkbox seçim
  const toggleSecim = (kod: string) => {
    setSecili(prev => {
      const s = new Set(prev);
      s.has(kod) ? s.delete(kod) : s.add(kod);
      return s;
    });
  };
  const tumunuSec = () => {
    if (secili.size === filtrelenmis.length) {
      setSecili(new Set());
    } else {
      setSecili(new Set(filtrelenmis.map(t => t.kod)));
    }
  };

  // Toplu pasif/aktif
  const topluPasif = async () => {
    if (secili.size === 0) return;
    if (!window.confirm(`${secili.size} tanımı pasife almak istiyor musunuz?`)) return;
    for (const kod of Array.from(secili)) {
      await fetch(`${API}/api/tanimlar2/kod/${encodeURIComponent(kod)}`, { method: 'DELETE', headers: headers() });
    }
    setSecili(new Set());
    yukle();
    bildir(`${secili.size} tanım pasife alındı`);
  };

  const topluAktif = async () => {
    if (secili.size === 0) return;
    for (const kod of Array.from(secili)) {
      await fetch(`${API}/api/tanimlar2/aktif/${encodeURIComponent(kod)}`, { method: 'PUT', headers: headers() });
    }
    setSecili(new Set());
    yukle();
    bildir(`${secili.size} tanım aktif edildi`);
  };

  // Yeni / Düzenle
  const yeniAc = () => {
    setDuzenlenen(null);
    setForm({ ad: '', aciklama: '', sira: liste.length + 1 });
    setHata(''); setModalAcik(true);
  };
  const duzenleAc = (t: any) => {
    setDuzenlenen(t);
    setForm({ ad: t.ad, aciklama: t.aciklama || '', sira: t.sira || 0 });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.ad.trim()) { setHata('Ad zorunludur'); return; }
    setHata(''); setYukleniyor(true);
    try {
      if (duzenlenen) {
        await axios.put(`${API}/api/tanimlar2/kod/${encodeURIComponent(duzenlenen.kod)}`,
          { ad: form.ad, aciklama: form.aciklama, sira: form.sira }, { headers: headers() });
        bildir('Güncellendi');
      } else {
        const maxSira = liste.reduce((m, t) => Math.max(m, t.sira || 0), 0);
        const yeniSira = maxSira + 1;
        const kod = `Z.1.${yeniSira}`;
        await axios.post(`${API}/api/tanimlar2/ekle`,
          { kod, ust_kod: 'Z.1', ad: form.ad, aciklama: form.aciklama, sira: yeniSira, modul_baglantisi: MODUL },
          { headers: headers() });
        bildir('Eklendi');
      }
      yukle(); setModalAcik(false);
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const tekSil = async (kod: string) => {
    if (!window.confirm('Bu tanımı pasife almak istiyor musunuz?')) return;
    await fetch(`${API}/api/tanimlar2/kod/${encodeURIComponent(kod)}`, { method: 'DELETE', headers: headers() });
    yukle();
  };

  const tekAktif = async (kod: string) => {
    await fetch(`${API}/api/tanimlar2/aktif/${encodeURIComponent(kod)}`, { method: 'PUT', headers: headers() });
    yukle();
  };

  return (
    <div>
      <div className="page-header">
        <h1>⚙️ Ziyaret Tanımları</h1>
        <p>Ziyaret konuları ve sınıflandırmaları</p>
      </div>

      {mesaj && (
        <div className="alert" style={{ background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb', borderRadius: 6, padding: '10px 16px', marginBottom: 12 }}>
          ✅ {mesaj}
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <input
              className="search-input"
              style={{ width: 240 }}
              placeholder="🔍 Ara..."
              value={aramaMetin}
              onChange={e => setAramaMetin(e.target.value)}
            />
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={pasifGoster} onChange={e => setPasifGoster(e.target.checked)} />
              Pasif kayıtları göster
            </label>
            <span style={{ fontSize: 12, color: '#888' }}>{filtrelenmis.length} kayıt</span>
          </div>

          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            {secili.size > 0 && (
              <>
                <span style={{ fontSize: 12, color: '#555' }}>{secili.size} seçili</span>
                <button className="btn btn-sm" style={{ background: '#27ae60', color: '#fff' }} onClick={topluAktif}>✅ Aktif Et</button>
                <button className="btn btn-sm" style={{ background: '#e67e22', color: '#fff' }} onClick={topluPasif}>⏸ Pasife Al</button>
              </>
            )}
            <button className="btn btn-success" onClick={yeniAc}>+ Yeni Konu</button>
          </div>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th style={{ width: 40 }}>
                  <input type="checkbox"
                    checked={filtrelenmis.length > 0 && secili.size === filtrelenmis.length}
                    onChange={tumunuSec}
                  />
                </th>
                <th style={{ width: 50 }}>Sıra</th>
                <th>Konu Adı</th>
                <th>Açıklama</th>
                <th style={{ width: 80 }}>Durum</th>
                <th style={{ width: 130 }}>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {filtrelenmis.map(t => (
                <tr key={t.kod} style={{ opacity: t.aktif ? 1 : 0.5 }}>
                  <td>
                    <input type="checkbox"
                      checked={secili.has(t.kod)}
                      onChange={() => toggleSecim(t.kod)}
                    />
                  </td>
                  <td style={{ textAlign: 'center', color: '#888' }}>{t.sira}</td>
                  <td><strong>{t.ad}</strong></td>
                  <td style={{ color: '#666', fontSize: 13 }}>{t.aciklama || '—'}</td>
                  <td>
                    <span style={{
                      display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11,
                      background: t.aktif ? '#d4edda' : '#f8d7da',
                      color: t.aktif ? '#155724' : '#721c24',
                    }}>
                      {t.aktif ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(t)}>Düzenle</button>
                    {t.aktif
                      ? <button className="btn btn-sm" style={{ background: '#e67e22', color: '#fff' }} onClick={() => tekSil(t.kod)}>Pasif</button>
                      : <button className="btn btn-sm" style={{ background: '#27ae60', color: '#fff' }} onClick={() => tekAktif(t.kod)}>Aktif</button>
                    }
                  </td>
                </tr>
              ))}
              {filtrelenmis.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: '#999', padding: 20 }}>
                  {aramaMetin ? `"${aramaMetin}" için sonuç yok` : 'Kayıt bulunamadı'}
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 420 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{duzenlenen ? 'Konu Düzenle' : 'Yeni Konu'}</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-group"><label>Konu Adı *</label>
                <input className="form-control" value={form.ad}
                  onChange={e => setForm({ ...form, ad: e.target.value })}
                  placeholder="Ziyaret konusu adı" />
              </div>
              <div className="form-group"><label>Açıklama</label>
                <textarea className="form-control" value={form.aciklama}
                  onChange={e => setForm({ ...form, aciklama: e.target.value })}
                  rows={2} placeholder="Kısa açıklama (opsiyonel)" />
              </div>
              <div className="form-group"><label>Sıra</label>
                <input className="form-control" type="number" value={form.sira}
                  onChange={e => setForm({ ...form, sira: Number(e.target.value) })} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => setModalAcik(false)}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
